<div class="card">
  <div class="row card-header">
    <div class="col-sm-8">
      <h3>Screening Utility</h3>
    </div>
    <div class="col-sm-4">
      <div class="text-right">
        <button type="button" class="btn btn-primary " routerLink="/screeningUtility">Back</button>
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <label class="col-form-label">Service Provider </label>
    <ng-select (change)="changeServiceProvider($event)" [(ngModel)]="serviceProvider" placeholder="Select Service Provider">
      <ng-option value="digi">DiGi</ng-option>
      <ng-option value="shuftiPro">Shufti Pro</ng-option>
      <ng-option value="idenfo">Idenfo</ng-option>
    </ng-select>
  </div>
  <br>
</div>

<div class="row" *ngIf="(serviceProvider == 'idenfo')">
  <div class="col-md-12 grid-margin">
    <div class="card">
      <div class="card-body">
        <form #screeningUtility="ngForm" (ngSubmit)="submitIdenfo(screeningUtility.value)" [formGroup]="utilityForm">
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Personal Details :</label>
          <div class="row">

            <div class="col-sm-4">
              <label class="col-form-label" for="fullname"> FULLNAME <span aria-hidden="true"
                  style="color:red;">*</span></label>
              <input class="form-control" id="fullname" placeholder="Enter Fullname" type="text"
                formControlName="fullname" [ngClass]="{'is-invalid':submitted && utilityForm.controls.fullname.errors}"
                name="fullname">
              <div *ngIf="submitted && utilityForm.controls.fullname.errors" class="invalid-feedback">
                Please Enter Fullname
              </div>
              <div
                *ngIf="submitted && (utilityForm.controls.fullname.errors?.pattern||utilityForm.controls.fullname.errors?.fullname)"
                class="invalid-feedback">
                Please Enter Valid Fullname
              </div>
              <div *ngIf="submitted && utilityForm.controls.fullname.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>

            <div class="col-sm-4">
              <label class="col-form-label" for="emailId">EMAIL ID </label>
              <input class="form-control" id="emailId" formControlName="emailId"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.emailId.errors}" placeholder="Enter Email ID"
                type="email" name="emailId">
              <div *ngIf="submitted && (utilityForm.controls.emailId.errors?.pattern)" class="invalid-feedback">
                Please Enter valid Email ID
              </div>
            </div>

            <div class="col-sm-4">
              <label for="settelemntCycle" class="col-form-label">GENDER </label>
              <ng-select formControlName="gender" placeholder="Select Gender"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.gender.errors}" name="gender">
                <ng-option ngValue="MALE">MALE</ng-option>
                <ng-option ngValue="FEMALE">FEMALE</ng-option>
              </ng-select>
              <div class="invalid-feedback">
                Please Select Gender
              </div>
            </div>

          </div>
          <br>
          <div class="row">

            <div class="col-sm-4">
              <label class="col-form-label" for="dateOfBirth">DATE OF BIRTH</label>
              <input type="date" class="form-control" formControlName="dateOfBirth"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.dateOfBirth.errors}" placeholder="dd-mm-yyyy"
                name="dateOfBirth" id="dateOfBirth" max="{{currentDate|date:'yyyy-MM-dd'}}">
              <div class="invalid-feedback">
                Please Select Date of Birth
              </div>
            </div>

            <div class="mb-3 col-md-4">
              <label class="col-form-label" for="nationality">NATIONALITY </label>
              <ng-select formControlName="nationality"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.nationality.errors}"
                placeholder="Select Nationality" type="text" [items]="countryDropdown" bindLabel="name" bindValue="name"
                name="nationality">
              </ng-select>
              <div class="invalid-feedback">
                Please Select Nationality
              </div>
            </div>

            <div class="col-sm-4">
              <label for="settelemntCycle" class="col-form-label">COUNTRY OF RESIDENCE </label>
              <ng-select formControlName="countryOfResidence" placeholder="Select Country Of Residence"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.countryOfResidence.errors}"
                id="countryOfResidence" [items]="countryDropdown" bindLabel="name" bindValue="name"
                name="countryOfResidence">
              </ng-select>
              <div class="invalid-feedback">
                Please Select Country Of Residence
              </div>
            </div>

          </div>
          <br>
          <hr>
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Identity Information :</label>

          <div class="row">

            <div class="col-sm-4">
              <label class="col-form-label" for="emiratesId">EMIRATES ID</label>
              <input class="form-control" formControlName="emiratesId"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.emiratesId.errors}" name="emiratesId"
                id="emiratesId" placeholder="Emirates ID" type="number" autocomplete="new-password" maxlength="20">
              <div
                *ngIf="submitted && (utilityForm.controls.emiratesId.errors?.pattern||utilityForm.controls.emiratesId.errors?.address)"
                class="invalid-feedback">
                Please Enter Valid Emirates ID
              </div>
              <div *ngIf="submitted && utilityForm.controls.emiratesId.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>

            <div class="col-sm-4">
              <label class="col-form-label" for="emiratesExpiry">EMIRATES EXPIRY DATE</label>
              <input type="date" class="form-control" formControlName="emiratesExpiry"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.emiratesExpiry.errors}"
                placeholder="dd-mm-yyyy" name="emiratesExpiry" id="emiratesExpiry"
                max="{{currentDate|date:'yyyy-MM-dd'}}">
              <div class="invalid-feedback">
                Please Select Emirates Expiry Date
              </div>
            </div>

          </div>
          <br>
          <div class="row">
            <div class="col-sm-4">
              <label class="col-form-label" for="passportNumber">PASSPORT NUMBER </label>
              <input class="form-control" formControlName="passportNumber"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.passportNumber.errors}" name="passportNumber"
                id="passportNumber" placeholder="Passport Number" type="text" autocomplete="new-password"
                maxlength="15">
              <div
                *ngIf="submitted && (utilityForm.controls.passportNumber.errors?.pattern||utilityForm.controls.passportNumber.errors?.passportNumber)"
                class="invalid-feedback">
                Please Enter Valid Passport Number
              </div>
              <div *ngIf="submitted && utilityForm.controls.passportNumber.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>
            <div class="col-sm-4">
              <label class="col-form-label" for="passportExpiry">PASSPORT EXPIRY DATE</label>
              <input type="date" class="form-control" formControlName="passportExpiry"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.passportExpiry.errors}"
                placeholder="dd-mm-yyyy" name="passportExpiry" id="passportExpiry"
                max="{{currentDate|date:'yyyy-MM-dd'}}">
              <div class="invalid-feedback">
                Please Select Passport Expiry Date
              </div>
            </div>
          </div>
          <br>
          <hr>

          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Contact Details :</label>

          <div class="row">
            <div class="col-sm-4">
              <label class="col-form-label" for="address">ADDRESS </label>
              <input class="form-control" formControlName="address"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.address.errors}" name="address" id="address"
                placeholder="Address" type="text" autocomplete="new-password" maxlength="30">
              <div
                *ngIf="submitted && (utilityForm.controls.address.errors?.pattern||utilityForm.controls.address.errors?.address)"
                class="invalid-feedback">
                Please Enter Valid Address
              </div>
              <div *ngIf="submitted && utilityForm.controls.address.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>
            <div class="col-sm-4">
              <label class="col-form-label" for="city">CITY </label>
              <input class="form-control" formControlName="city"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.city.errors}" name="city" id="city"
                placeholder="City" type="text" autocomplete="new-password" maxlength="30" pattern="[a-zA-Z][a-zA-Z ]+">
              <div
                *ngIf="submitted && (utilityForm.controls.city.errors?.pattern||utilityForm.controls.city.errors?.city)"
                class="invalid-feedback">
                Please Enter Valid City
              </div>
              <div *ngIf="submitted && utilityForm.controls.city.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>
            <div class="col-sm-4">
              <label for="settelemntCycle" class="col-form-label">STATE </label>
              <ng-select formControlName="state" placeholder="Select State"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.state.errors}" id="state" name="state">
                <ng-option ngValue="ABU DHABI">ABU DHABI</ng-option>
                <ng-option ngValue="AJMAN">AJMAN</ng-option>
                <ng-option ngValue="DUBAI">DUBAI</ng-option>
                <ng-option ngValue="FUJAIRAH">FUJAIRAH</ng-option>
                <ng-option ngValue="RAS AL KHAIMAH">RAS AL KHAIMAH</ng-option>
                <ng-option ngValue="SHARJAH">SHARJAH</ng-option>
                <ng-option ngValue="UMM AL QUWAIN">UMM AL QUWAIN</ng-option>
              </ng-select>
              <div class="invalid-feedback">
                Please Select State
              </div>
            </div>

          </div>
          <br>

          <div class="row">
            <div class="col-sm-4">
              <label class="col-form-label" for="poBox">ZIP / POSTAL CODE </label>
              <input class="form-control" formControlName="poBox"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.poBox.errors}" name="poBox" id="poBox"
                placeholder="Postal Code" type="number" autocomplete="new-password" maxlength="6">
              <div
                *ngIf="submitted && (utilityForm.controls.poBox.errors?.pattern||utilityForm.controls.poBox.errors?.poBox)"
                class="invalid-feedback">
                Please Enter Valid Postal Code
              </div>
              <div *ngIf="submitted && utilityForm.controls.poBox.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>
            <div class="col-sm-4">
              <label class="col-form-label" for="contactNumber">CONTACT NUMBER </label>
              <input class="form-control" formControlName="contactNumber"
                [ngClass]="{'is-invalid':submitted && utilityForm.controls.contactNumber.errors}" name="contactNumber"
                id="contactNumber" placeholder="Contact Number" type="text" (keypress)="OnlyNumbersAllowed($event)"
                autocomplete="new-password" maxlength="10">
              <div
                *ngIf="submitted && (utilityForm.controls.contactNumber.errors?.pattern||utilityForm.controls.contactNumber.errors?.contactNumber)"
                class="invalid-feedback">
                Please Enter Valid Contact Number
              </div>
              <div *ngIf="submitted && utilityForm.controls.contactNumber.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>

          </div>
          <br>
          <div class="d-flex justify-content-center mt-2">
            <button class="btn btn-success" type="submit"><span id="loading" role="status" aria-hidden="true"></span>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="(serviceProvider == 'shuftiPro')">
  <div class="col-md-12 grid-margin">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Screening Type :</label>
          <br>
          <input class="form-check-input" style="margin-top:10px;" type="radio" name="businessType" [(ngModel)]="selectedBusinessType" value="individual" (ngModelChange)="changeScreenType()" />
          <label class=" col-form-label form-check-label" for="" style="margin-left: 5px;">Individual</label>
          <input class="form-check-input" style="margin-top:10px; margin-left: 10px;" type="radio" name="businessType" [(ngModel)]="selectedBusinessType" value="business" (ngModelChange)="changeScreenType()" />
          <label class=" col-form-label form-check-label" for="" style="margin-left: 35px;">Business</label>
          <br>
        </div>
        
        <hr>

        <form #screeningUtilityShufti="ngForm" (ngSubmit)="submitShufti(screeningUtilityShufti.value)"
          [formGroup]="utilityFormShufti">
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Personal Details :</label>
          <div class="row">

            <div class="col-md-4">
              <label class="col-form-label" for="fullname"> FULLNAME <span aria-hidden="true"
                  style="color:red;">*</span></label>
              <input class="form-control" id="fullname" placeholder="Enter Fullname" type="text"
                formControlName="fullname" required
                [ngClass]="{'is-invalid':submitted && utilityFormShufti.controls.fullname.errors}" name="fullname">

              <div *ngIf="submitted && utilityFormShufti.controls.fullname.errors?.required" class="invalid-feedback">
                Please Enter Fullname
              </div>
              <div
                *ngIf="submitted && (utilityFormShufti.controls.fullname.errors?.pattern)"
                class="invalid-feedback">
                Please Enter Valid Fullname
              </div>
              <div *ngIf="submitted && utilityFormShufti.controls.fullname.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>

            <div class="col-md-4" *ngIf="selectedBusinessType === 'individual'">
              <label class="col-form-label" for="dateOfBirth">DATE OF BIRTH </label>
              <input type="date" class="form-control" formControlName="dateOfBirth"
                [ngClass]="{'is-invalid':submitted && utilityFormShufti.controls.dateOfBirth.errors}"
                placeholder="dd-mm-yyyy" name="dateOfBirth" id="dateOfBirth" max="{{currentDate|date:'yyyy-MM-dd'}}">
            </div>

            <div class="col-md-4" *ngIf="selectedBusinessType === 'individual'">
              <label class="col-form-label" for="nationality">Country </label>
              <ng-select formControlName="nationality" [multiple]=true
                [ngClass]="{'is-invalid':submitted && utilityFormShufti.controls.nationality.errors}"
                placeholder="Select Country" type="text" [items]="countryDropdown" bindLabel="name" 
                name="nationality">
              </ng-select>
            </div>

          </div>
          <br>
          <hr>
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Screening Configuration :</label>
          <div class="row d-flex">
            <div class="col-md-4">
              <label class="col-form-label" for="searchList">Search List</label>
              <ng-select [multiple]="true" bindLabel="title" bindValue="key" (remove)="removeSearchName($event)"
                (add)="addSearchName($event)" [selectableGroup]="true" [selectableGroupAsModel]="false" id="userType"
                placeholder="Select Search List" [inputAttrs]="{maxlength: '100'}" [items]="searchListDropdown"
                [selectableGroup]="true" [closeOnSelect]="false" groupBy="isSelectedALL" [(ngModel)]="finalSearchList"
                [ngModelOptions]="{standalone: true}">
                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                    [ngModelOptions]="{standalone: true}" />
                  {{ item.isSelectedALL | uppercase }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <ng-container *ngIf="item.key !=='ALL'">
                    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                      [ngModelOptions]="{standalone: true}" />
                    {{ item.title }}
                  </ng-container>
                </ng-template>
              </ng-select>

            </div>



            <div class="col-md-1 "></div>
            <div class="col-md-3 ">
              <br>
              <input class="form-check-input" style="margin-top: 10px;" type="checkbox" formControlName="aliasCheck"
                [ngClass]="{'is-invalid':submitted && utilityFormShufti.controls.aliasCheck.errors}" name="aliasCheck">
              <label class=" col-form-label form-check-label" for="creditType" style="margin-left: 5px;"> Enable Alias
                Search</label>
            </div>
            <div class="col-md-1 "></div>
            <div class="col-md-3 ">
              <br>
              <input class="form-check-input" style="margin-top: 10px;" type="checkbox" formControlName="rcaCheck"
                [ngClass]="{'is-invalid':submitted && utilityFormShufti.controls.rcaCheck.errors}" name="rcaCheck">
              <label class=" col-form-label form-check-label" for="creditType" style="margin-left: 5px;"> Enable RCA
                Search</label>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-4">
              <label class="col-form-label" for="contactNumber">MATCH SCORE </label>
              <div class="d-flex">
                <input type="range" min="1" max="100" step="1" class="form-control-range slider"
                  [value]="sliderValueTemp" id="formControlRange" (input)="valueChanged($event)">
                <input for="formControlValue" id="scoreInput" style="width: 50px; margin-left: 5px;" maxlength="3"
                  type="text" (input)="inputChange($event)" [value]="sliderValue"
                  onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
              </div>
            </div>
          </div>
          <br>
          <div class="d-flex justify-content-center mt-2">
            <button class="btn btn-success" type="submit"><span id="loading" role="status" aria-hidden="true"></span>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="(serviceProvider == 'digi')">
  <div class="col-md-12 grid-margin">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Screening Type :</label>
          <br>
          <input class="form-check-input" style="margin-top:10px;" type="radio" name="businessType" [(ngModel)]="selectedBusinessType" value="individual" (ngModelChange)="changeScreenType()" />
          <label class=" col-form-label form-check-label" for="" style="margin-left: 5px;">Individual</label>
          <input class="form-check-input" style="margin-top:10px; margin-left: 10px;" type="radio" name="businessType" [(ngModel)]="selectedBusinessType" value="business" (ngModelChange)="changeScreenType()" />
          <label class=" col-form-label form-check-label" for="" style="margin-left: 35px;">Business</label>
          <br>
        </div>
        
        <hr>

        <form #screeningUtilityDigi="ngForm" (ngSubmit)="submitDigi(screeningUtilityDigi.value)"
          [formGroup]="utilityFormDigi">
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Personal Details :</label>
          <div class="row">

            <div class="col-md-4">
              <label class="col-form-label" for="fullname"> FULLNAME <span aria-hidden="true"
                  style="color:red;">*</span></label>
              <input class="form-control" id="fullname" placeholder="Enter Fullname" type="text"
                formControlName="fullname" required
                [ngClass]="{'is-invalid':submitted && utilityFormDigi.controls.fullname.errors}" name="fullname">

              <div *ngIf="submitted && utilityFormDigi.controls.fullname.errors?.required" class="invalid-feedback">
                Please Enter Fullname
              </div>
              <div
                *ngIf="submitted && (utilityFormDigi.controls.fullname.errors?.pattern)"
                class="invalid-feedback">
                Please Enter Valid Fullname
              </div>
              <div *ngIf="submitted && utilityFormDigi.controls.fullname.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>

            <div class="col-md-4" *ngIf="selectedBusinessType === 'individual'">
              <label class="col-form-label" for="dateOfBirth">DATE OF BIRTH </label>
              <input type="date" class="form-control" formControlName="dateOfBirth"
                [ngClass]="{'is-invalid':submitted && utilityFormDigi.controls.dateOfBirth.errors}"
                placeholder="dd-mm-yyyy" name="dateOfBirth" id="dateOfBirth" max="{{currentDate|date:'yyyy-MM-dd'}}">
            </div>

            <div class="col-md-4" *ngIf="selectedBusinessType === 'individual'">
              <label class="col-form-label" for="nationality">Country </label>
              <ng-select formControlName="nationality" [multiple]=true
                [ngClass]="{'is-invalid':submitted && utilityFormDigi.controls.nationality.errors}"
                placeholder="Select Country" type="text" [items]="countryDropdown" bindLabel="name" 
                name="nationality">
              </ng-select>
            </div>

          </div>
          <br>
          <hr>
          <label class="col-form-label" style="font-weight: bolder; font-size: large;">Screening Configuration :</label>
          <div class="row d-flex">
            <div class="col-md-4">
              <label class="col-form-label" for="searchList">Search List</label>
              <ng-select [multiple]="true" bindLabel="title" bindValue="key" (remove)="removeSearchName($event)"
                (add)="addSearchName($event)" [selectableGroup]="true" [selectableGroupAsModel]="false" id="userType"
                placeholder="Select Search List" [inputAttrs]="{maxlength: '100'}" [items]="searchListDigiDropdown"
                [selectableGroup]="true" [closeOnSelect]="false" groupBy="isSelectedALL" [(ngModel)]="finalSearchList"
                [ngModelOptions]="{standalone: true}">
                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                    [ngModelOptions]="{standalone: true}" />
                  {{ item.isSelectedALL | uppercase }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <ng-container *ngIf="item.key !=='ALL'">
                    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                      [ngModelOptions]="{standalone: true}" />
                    {{ item.title }}
                  </ng-container>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-4">
              <label class="col-form-label" for="contactNumber">MATCH SCORE </label>
              <div class="d-flex">
                <input type="range" min="1" max="100" step="1" class="form-control-range slider"
                  [value]="sliderValueTemp" id="formControlRange" (input)="valueChanged($event)">
                <input for="formControlValue" id="scoreInput" style="width: 50px; margin-left: 5px;" maxlength="3"
                  type="text" (input)="inputChange($event)" [value]="sliderValue"
                  onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
              </div>
            </div>
          </div>
          <br>
          <div class="d-flex justify-content-center mt-2">
            <button class="btn btn-success" type="submit"><span id="loading" role="status" aria-hidden="true"></span>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>